import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./HeroSlider.scss";
import { NavLink } from "react-router-dom";

const slideData = [
  {
    id: 1,
    smallTitle: "Vet İzmire Hoşgeldiniz",
    mainTitle: "Evcil Dostlarınız İçin Sevgi ve Güvenin Adresi",
    buttonText: "Daha Fazlasını Gör",
    bgImage: "/slider0.jpg",
    link: "/hakkimizda",
  },
  {
    id: 2,
    smallTitle: "HİKAYELERİNE ORTAK OLUYORUZ",
    mainTitle: "Her Patinin Bir Öyküsü Var",
    buttonText: "Hikayeleri Oku",
    bgImage: "/slider1.jpg",
    link: "/pati-hikayeleri",
  },
  {
    id: 3,
    smallTitle: "Vet İzmir Ailesi",
    mainTitle: "Uzman Ekibimizle Tanışın",
    buttonText: "Yazıları Oku",
    bgImage: "/slider2.jpg",
    link: "/hekimlerimizden",
  },
];

const HeroSlider = () => {
  return (
    <div className="hero-slider-container">
      <Swiper
        modules={[Navigation, EffectFade, Autoplay]}
        navigation={{
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        }}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 5000, // 5 saniyede bir otomatik geçsin
          disableOnInteraction: true,
        }}
        className="my-hero-swiper"
      >
        {slideData.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="slide-wrapper">
              {/* Arka plan görseli artık bir <img> etiketi */}
              <img
                src={slide.bgImage}
                alt={slide.mainTitle}
                className="slide-background-image"
              />
              {/* İçerik katmanı */}
              <div className="slide-content">
                {/* Sol Taraf: Yazılar */}
                <div className="slide-text-content">
                  <div className="small-title">
                    <h4>{slide.smallTitle}</h4>
                    <div className="title-border"></div>
                  </div>
                  <h1 className="main-title">{slide.mainTitle}</h1>
                  <NavLink to={slide.link}>
                    <button className="slide-button">{slide.buttonText}</button>
                  </NavLink>
                </div>
                {/* Sağ Taraf: Özel Navigasyon Butonlarımız */}
                <div className="swiper-navigation-custom">
                  <div className="swiper-button-prev-custom">
                    <FaArrowLeft />
                  </div>
                  <div className="swiper-button-next-custom">
                    <FaArrowRight />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroSlider;
